import EntityContentItemRepeaterItem from './EntityContentItemRepeaterItem';

export default EntityContentItemRepeaterItem;
